module.exports = __webpack_public_path__ + "static/media/game-racquet.33386e90.png";